
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 11.938 11.068"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"id":"Path_32390","data-name":"Path 32390","d":"M11.188 3.359A2.666 2.666 0 008.469.75a2.723 2.723 0 00-2.5 1.585A2.723 2.723 0 003.469.75 2.666 2.666 0 00.75 3.359c0 4.187 5.219 6.958 5.219 6.958s5.219-2.771 5.219-6.958z","fill":"none","stroke":"#6d7392","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}})])
          )
        }
      }
    